export const DEFAULT_PIZZA_ETA_TIME_MINS = 5;
